<!--
 * @Author: LiuChuanQi
 * @Date: 2022-11-25 16:42:37
 * @LastEditTime: 2023-01-05 19:00:15
 * @LastEditors: LiuChuanQi
 * @Description:  注册页面
 * @FilePath: \speedtest-bigdata-v2\src\components\common\login\register.vue
 *
-->
<template>
  <div class="register-content">
    <div
      class="close-icon"
      @click.stop="closeRegister"
    ></div>
    <div class="title">注册</div>
    <div class="input-content">
      <div class="input-item">
        <input
          type="text"
          placeholder="设置用户名，5-20字符"
          class="account"
          :class="{ error: errorInfor }"
          v-model.trim="submitInfor.name"
          @blur="blurEvent('name')"
          @input="inputEvent('name')"
          v-input
        />
        <div class="bottom-tip">{{ nameErrorInfor }}</div>
      </div>
      <div class="input-item">
        <input
          type="text"
          placeholder="手机号"
          class="account"
          :class="{ error: errorInfor }"
          v-model.trim="submitInfor.phone"
          @blur="blurEvent('phone')"
          @input="inputEvent('phone')"
          v-input
        />
        <div class="bottom-tip">{{phoneErrorInfor}}</div>
      </div>
      <div class="input-item">
        <input
          type="password"
          placeholder="设置密码"
          class="account"
          :class="{ error: errorInfor }"
          v-model="submitInfor.password"
          @blur="blurEvent('password')"
          @input="inputEvent('password')"
          @paste="pastePassword"
        />
        <div class="bottom-tip">{{passwordErrorInfor}}</div>
      </div>
      <div class="input-item">
        <input
          type="password"
          placeholder="确认密码"
          class="account"
          :class="{ error: errorInfor }"
          v-model="submitInfor.rePassword"
          @blur="blurEvent('rePassword')"
          @paste="pasteRePassword"
        />
        <div class="bottom-tip">{{rePasswordErrorInfor}}</div>
      </div>
      <div class="input-item item2">
        <div style="position: relative;height:100%">
          <input
            type="text"
            placeholder="验证码"
            class="account codeInput"
            :class="{ error: errorInfor }"
            v-model.trim="submitInfor.code"
            @blur="blurEvent('code')"
          />
          <div class="jg"></div>
          <waterproof
            :judgeFunction="judgeFunction"
            :showPlugin="showPlugin"
            v-if="codeStaus == 0 || codeStaus == 2"
            :CaptchaAppId="waterKey"
            :callback="callback"
            class="get-code"
            :title="codeTitle"
            :options="{needFeedBack: false}"
          ></waterproof>
          <div
            class="count-down"
            v-if="codeStaus == 1"
          >{{ timeInfor }}</div>
          <div class="bottom-tip">{{ codeErrorInfor }}</div>
          <div class="reset-password">收不到验证码？
            <div class="tips">
              <p style="margin-bottom:6px;">收不到验证码可尝试以下方案：</p>
              <p>1.通信网络异常请重启手机</p>
              <p>2.查看手机设置-信息-黑名单</p>
              <p>3.检查是否有安全软件拦截了验证码</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="login"
      @click.stop="toLogin"
    >注册</div>
    <!-- <waterproof :judgeFunction="judgeFunction" :showPlugin="showPlugin" class="login" CaptchaAppId="2068909762" :callback="callback" title="登录"></waterproof> -->
    <div class="user-infor">
      <span
        class="check-box"
        :class="{ active: isAccept }"
        @click="toggleClick"
      ></span>
      <div class="infor-content">
        <p>
          阅读并同意
          <a
            class="heightLight"
            href="https://www.speedtest.cn/terms"
            target="_blank"
          >《用户协议》</a>、
          <a
            class="heightLight"
            href="http://www.speedtest.cn/privacy"
            target="_blank"
          >《隐私政策》</a>和
        </p>
        <p><a
            class="heightLight"
            href="http://www.speedtest.cn/promise"
            target="_blank"
          >《产品使用承诺书》</a></p>
      </div>
    </div>
    <div class="jg"></div>
    <div class="toLogin">
      已有账号，<span
        class="heightLight"
        @click.stop="closeRegister"
      >去登陆</span>
    </div>
  </div>
</template>

<script>
import { verifyPhone, verifyAccount, verifyPassword, throttle } from '@/utils/hooks'
import { getRegisterCode, register, checkAccount } from '@/api/login'
import {waterKey} from '@/config/waterProofKey'

export default {
  props: {
    showRegister: {
      type: Boolean
    },
    isShowInfor: {
      type: Boolean
    },
    isShowInfor2: {
      type: Boolean
    }
  },

  data() {
    return {
      isAccept: false, //使用同意用户协议
      errorInfor: '', //错误提示信息
      errType: 0, //0代表没错误 1用户名已存在 手机号错误 两次密码不一致 验证码
      submitInfor: {
        name: '',
        phone: '',
        password: '',
        rePassword: '',
        code: ''
      },
      pwd: '', //显示的星星
      rePwd: '', //确认密码显示的星星
      eqeq: 111,
      codeTitle: '发送验证码', //获取验证码按钮的提示信息
      codeStaus: 0, //0 未发送验证码，1点击发送验证码 2发送完成可重复发送
      timer: null, //验证码倒计时
      timeInfor: '重新发送(60s)', //当时的计时时间
      showPlugin: false, //控制防水墙弹窗
      nameErrorInfor: '',
      phoneErrorInfor: '',
      passwordErrorInfor: '',
      rePasswordErrorInfor: '',
      codeErrorInfor: '',
      waterKey
    }
  },
  methods: {
    pasteRePassword() {
      this.rePwd = ''
      this.submitInfor.rePassword = ''
    },
    pastePassword() {
      this.pwd = ''
      this.submitInfor.password = ''
    },
    closeRegister() {
      this.$emit('update:showRegister', false)
    },
    async toLogin() {
      if (!this.isAccept) {
        //this.msgInfo('请先同意用户协议')
        this.$emit('update:isShowInfor', true)
        setTimeout(() => {
          this.$emit('update:isShowInfor', false)
        }, 2000)
        return
      }
      await this.blurEvent('name')
      await this.blurEvent('phone')
      this.blurEvent('password')
      this.blurEvent('rePassword', true)
      this.blurEvent('code')
      if (this.nameErrorInfor == '' && this.phoneErrorInfor == '' && this.passwordErrorInfor == '' && this.rePasswordErrorInfor == '' && this.codeErrorInfor == '' && this.submitInfor.name && this.submitInfor.password && this.submitInfor.rePassword && this.submitInfor.phone && this.submitInfor.code) {
        let data = {
          tenantId: '0',
          userName: this.submitInfor.name,
          password: this.submitInfor.password,
          rePassword: this.submitInfor.rePassword,
          phone: this.submitInfor.phone,
          verificationCode: this.submitInfor.code
        }
        register({ apiVersion: 'v1', data })
          .then(res => {
            if (res.code == 200) {
              this.$emit('update:isShowInfor2', true)
              setTimeout(() => {
                this.$emit('update:showRegister', false)
              }, 500)
            }
            res.code == 200 ? '' : (this.codeErrorInfor = res.errorMsg)
          })
          .catch(err => {
            this.codeErrorInfor = err.errorMsg
          })
      } else {
        // this.blurEvent('name')
        // this.blurEvent('password')
        // this.blurEvent('rePassword')
        // this.blurEvent('phone')
        // this.blurEvent('code')
      }
    },
    toggleClick() {
      this.isAccept = !this.isAccept
    },
    //腾讯防水墙回调
    callback(res) {
      // 回调函数根据 ticket 和 errorCode （而非 ret）的情况做处理
      this.showPlugin = false
      if (res.ticket) {
        //根据errorCode情况做特殊处理
        if (res.errorCode) {
          //自定义容灾逻辑（例如跳过这次验证） 比如连续错误三次 刷新连续三次
        } else if (res.ret == 2 && !res.ticket) {
          //用户手动关闭
        } else {
          //验证成功
          //可以发送账号密码
          this.timeInfor = '重新发送(60s)'
          this.timeDown(59)
          this.codeStaus = 1
          const {ticket, randstr} = res
          getRegisterCode({ apiVersion: 'v1', phone: this.submitInfor.phone,ticket, randStr:randstr })
            .then(res => {
              if (res.code == 200) {
              }
              res.code == 200 ? '' : (this.codeErrorInfor = res.errorMsg)
            })
            .catch(err => {
              this.codeErrorInfor = err.errorMsg
            })
        }
      }
    },
    //显示弹窗前的校验逻辑
    judgeFunction() {
      if (this.submitInfor.phone) {
        if (!this.isAccept) {
          //this.msgInfo('请先同意用户协议')
          this.$emit('update:isShowInfor', true)
          setTimeout(() => {
            this.$emit('update:isShowInfor', false)
          }, 2000)
          return
        }
        this.showPlugin = true
      } else {
        this.phoneErrorInfor = '请输入手机号'
      }
    },
    getCode() {
      //获取验证码
      //成功
      this.codeStaus = 2
      this.timeInfor = '重新发送(60s)'
      this.codeTitle = '重新发送'
      clearInterval(this.timer)
      this.timer = null
    },
    //验证码计时
    timeDown(time) {
      let item = time
      this.timer = setInterval(() => {
        if (item > 0 && item <= time) {
          this.timeInfor = `重新发送(${item--}s)`
        } else {
          this.codeStaus = 2
          this.codeTitle = '重新发送'
          this.timeInfor = '重新发送(60s)'
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },
    //正则校验
    //校验确认代码 same为true校验一致性
    validateConfirmPass(value, same) {
      let reg = /^[\S]*$/
      let reg2 = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-zA-Z]|[0-9]){6,20}$/
      if (!value) {
        return '请输入确认密码'
      } else if (!reg.test(value)) {
        return '密码不允许存在空格'
      } else if (!reg2.test(value)) {
        return '请设置6-20位字母/数字/符号两种以上的组合密码'
      } else if (value !== this.submitInfor.password && same) {
        return '确认密码不一致'
      } else {
        return ''
      }
    },
    //校验第一次输入的代码
    validatePass(value) {
      let reg = /^[\S]*$/
      let reg2 = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[\(\)])+$)([^(0-9a-zA-Z)]|[\(\)]|[a-zA-Z]|[0-9]){6,20}$/
      if (!value) {
        return '请输入密码'
      } else if (!reg.test(value)) {
        return '密码不允许存在空格'
      } else if (!reg2.test(value)) {
        return '请设置6-20位字母/数字/符号两种以上的组合密码'
      } else {
        return ''
      }
    },
    //校验用户名
    async validateAccount(value) {
      if (!value) {
        this.nameErrorInfor = '请输入用户名'
      } else if (value.length > 20 || value.length < 5) {
        this.nameErrorInfor = '用户名限制5-20个字符'
      } else {
        await this.checkSame(value, 'userName', 'nameErrorInfor')
        //此处需要校验用户是否存在
        //return ''
      }
    },

    //校验手机号
    async validatePhone(value) {
      if (!value) {
        this.phoneErrorInfor = '请输入手机号'
      } else if (!verifyPhone(value)) {
        this.phoneErrorInfor = '请输入正确的手机号格式'
      } else {
        await this.checkSame(value, 'phone', 'phoneErrorInfor')
        //此处需要校验手机号是否存在
        //return ''
      }
    },
    //校验验证码
    validateCode(value) {
      if (!value) {
        return '请输入验证码'
      } else {
        return ''
      }
    },
    //输入框的校验部分
    async inputEvent(type) {
      switch (type) {
        case 'name':
          //校验名字
          await this.validateAccount(this.submitInfor[type])
          break
        case 'phone':
          //校验手机号
          await this.validatePhone(this.submitInfor[type])
          break
        case 'password':
          this.passwordErrorInfor = this.validatePass(this.submitInfor[type])
          break
        case 'rePassword':
          //this.rePasswordErrorInfor = this.validateConfirmPass(this.submitInfor[type])
          break
        case 'code':
          this.codeErrorInfor = this.validateCode(this.submitInfor[type])
          break
      }
    },
    async checkSame(value, type, errName) {
      await checkAccount({ apiVersion: 'v1', [type]: value })
        .then(res => {
          if (res.code == 200) {
            this[errName] = ''
          }
        })
        .catch(err => {
          this[errName] = err.errorMsg
        })
    },
    async blurEvent(type, same = false) {
      this.submitInfor[type] = this.submitInfor[type].replace(/\s+/g, '')
      switch (type) {
        case 'name':
          //校验名字
          await this.validateAccount(this.submitInfor[type])
          break
        case 'phone':
          //校验手机号
          await this.validatePhone(this.submitInfor[type])
          break
        case 'password':
          this.passwordErrorInfor = this.validatePass(this.submitInfor[type])
          break
        case 'rePassword':
          this.rePasswordErrorInfor = this.validateConfirmPass(this.submitInfor[type], same)
          break
        case 'code':
          this.codeErrorInfor = this.validateCode(this.submitInfor[type])
          break
      }
    }
  },
  mounted() {},
  // computed: {
  //   //缓存上一次密码
  //   oldPwd() {
  //     return JSON.parse(JSON.stringify(this.pwd))
  //   },
  //   oldRePwd() {
  //     return JSON.parse(JSON.stringify(this.rePwd))
  //   }
  // },
  // watch: {
  //   oldPwd: {
  //     handler(val, oldV) {
  //       //监听登录的密码输入框，将密文显示为*
  //       this.pwd = this.pwd.replace(/./g, '*')
  //       if (oldV.length > val.length) {
  //         //进行删除操作   this.form.password就是定义在data中用来存实际密码的变量
  //         this.submitInfor.password = this.submitInfor.password.substring(0, this.submitInfor.password.length - (oldV.length - val.length))
  //       } else {
  //         this.submitInfor.password += val.replace(/\s+/g, '').replace(/[*]/g, '')
  //       }
  //     },
  //     deep: true
  //   },
  //   oldRePwd: {
  //     handler(val, oldV) {
  //       //监听登录的密码输入框，将密文显示为*
  //       this.rePwd = this.rePwd.replace(/./g, '*')
  //       if (oldV.length > val.length) {
  //         //进行删除操作   this.form.password就是定义在data中用来存实际密码的变量
  //         this.submitInfor.rePassword = this.submitInfor.rePassword.substring(0, this.submitInfor.rePassword.length - (oldV.length - val.length))
  //       } else {
  //         this.submitInfor.rePassword += val.replace(/\s+/g, '').replace(/[*]/g, '')
  //       }
  //     },
  //     deep: true
  //   }
  // }
}
</script>

<style lang="less" scoped>
.register-content {
  width: 382px;
  // height: 507px;
  background: rgba(11, 25, 66, 0.9);
  border-radius: 8px;
  border: 1px solid #00d2fa;
  position: absolute;
  left: 50%;
  top: 50%;
  padding: 40px 56px 16px;
  box-sizing: border-box;
  transform: translateX(-50%) translateY(-50%);
  .close-icon {
    width: 14px;
    height: 14px;
    background: url(@/assets/image/icon/closeLogin.png);
    background-size: 100%;
    position: absolute;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }
  .title {
    height: 22px;
    line-height: 22px;
    font-weight: bold;
    color: #ffffff;
    font-size: 14px;
  }
  .input-content {
    margin-top: 27px;
    .input-item {
      height: 58px;
      &.item2 {
        height: 68px;
        div {
          .bottom-tip {
            width: 200%;
            height: 58px;
            line-height: 58px;
            color: #ff564d;
            font-size: 20px;
            transform: scale(0.5);
            position: relative;
            top: -14.5px;
            left: -50%;
          }
        }
      }
      .account {
        width: 100%;
        height: 39px;
        border-radius: 4px;
        border: 1px solid #5b6189;
        display: block;
        background: rgba(11, 25, 66, 0.9);
        color: #ffffff;
        line-height: 39px;
        padding: 10px 16px 9px;
        box-sizing: border-box;
        &:focus {
          outline: none; //这个可以把原来的线去掉
          border: 1px solid #ddd;
        }
        &.error {
          border: 1px solid #ff564d;
        }
        &.codeInput {
          margin-bottom: 0;
        }
      }
      .error-infor {
        height: 32px;
        line-height: 32px;
        font-weight: 400;
        color: #ff564d;
        font-size: 10px;
      }

      .jg {
        position: absolute;
        width: 1px;
        height: 16px;
        top: 11px;
        right: 96px;
        background: #58658a;
      }
      .get-code {
        position: absolute;
        top: 10px;
        right: 48px;
        transform: translateX(50%);
        height: 19px;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;
        font-size: 13px;
        cursor: pointer;
      }
      .count-down {
        position: absolute;
        top: 10px;
        right: 48px;
        transform: translateX(50%);
        height: 19px;
        font-weight: 400;
        color: #82889a;
        line-height: 19px;
        font-size: 13px;
      }
    }
  }
  .login {
    height: 39px;
    background: #00d2fa;
    border-radius: 4px;
    line-height: 39px;
    text-align: center;
    font-weight: bold;
    color: #ffffff;
    font-size: 13px;
    cursor: pointer;
    // margin-top: 19px;
  }
  .user-infor {
    position: relative;
    padding: 13px 0px 13px 21px;
    box-sizing: border-box;
    .check-box {
      width: 10px;
      height: 10px;
      background: #ffffff;
      border-radius: 2px;
      border: 1px solid #979797;
      position: absolute;
      top: 15px;
      left: 0;
      cursor: pointer;

      &.active {
        background: url('@/assets/image/icon/allScreen.png') no-repeat center;
        background-size: 100%;
        border: none;
      }
    }
    .infor-content {
      p {
        height: 16px;
        line-height: 16px;
        font-size: 11px;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
  .jg {
    height: 1px;
    background: #82889a;
    opacity: 0.2;
  }
  .toLogin {
    height: 16px;
    line-height: 16px;
    font-size: 11px;
    margin-top: 13px;
    text-align: center;
    font-weight: 400;
    color: #82889a;
  }
  .heightLight {
    color: #82ebff;
    cursor: pointer;
  }
  .bottom-tip {
    width: 200%;
    height: 38px;
    line-height: 38px;
    color: #ff564d;
    font-size: 20px;
    transform: scale(0.5);
    position: relative;
    top: -9.5px;
    left: -50%;
  }
}
a {
  text-decoration: none;
}

.reset-password {
  position: absolute;
  right: 0;
  bottom: 6px;
  cursor: pointer;
  color: #82ebff;
  line-height: 16px;
  font-size: 11px;
  .tips {
    display: none;
    position: absolute;
    left: -91px;
    top: -102px;
    height: 99px;
    width: 215px;
    background: url(@/assets/image/icon/tipInfor.png);
    background-size: 100%;
    padding: 10px 18px;
    padding-right: 0px;
    box-sizing: border-box;
    p {
      font-size: 11px;
      height: 16px;
      line-height: 16px;
      font-weight: 400;
      color: #fff;
    }
  }
  &:hover {
    text-decoration: underline;
    .tips {
      display: block;
    }
  }
}
</style>
